import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RegisterHub() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    password: '',
    role: 'hub',
    hubName: '',
    description: '',
    deliveryRadiusKm: 50,
    minimumOrderAmount: 0,
    commissionRate: 10,
    pickupAddress: {
      street: '',
      suburb: '',
      state: '',
      postcode: ''
    }
  });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.includes('.')) {
      const [parent, child] = name.split('.');
      setFormData(prev => ({
        ...prev,
        [parent]: {
          ...prev[parent],
          [child]: value
        }
      }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    // Prepare data for registration API
    const submitData = {
      name: formData.name,
      email: formData.email,
      password: formData.password,
      role: 'hub',
      farmName: formData.hubName, // Reuse farmName field for hubName
      hubSettings: {
        hubName: formData.hubName,
        description: formData.description,
        deliveryRadiusKm: formData.deliveryRadiusKm,
        minimumOrderAmount: formData.minimumOrderAmount,
        commissionRate: formData.commissionRate,
        pickupAddress: formData.pickupAddress
      }
    };
    
    const success = await register(submitData);
    setLoading(false);
    if (success) {
      navigate('/hub-dashboard');
    }
  };

  return (
    <div className="max-w-2xl mx-auto">
      <div className="bg-white p-8 rounded-lg shadow-md">
        <h1 className="text-2xl font-bold mb-6">Register as a Hub</h1>
        <p className="text-gray-600 mb-6">Connect local farmers with your community</p>
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 mb-2">Your Name *</label>
            <input type="text" name="name" value={formData.name} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required />
          </div>
          
          <div>
            <label className="block text-gray-700 mb-2">Email *</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required />
          </div>
          
          <div>
            <label className="block text-gray-700 mb-2">Password *</label>
            <input type="password" name="password" value={formData.password} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required />
          </div>
          
          <div>
            <label className="block text-gray-700 mb-2">Hub Name *</label>
            <input type="text" name="hubName" value={formData.hubName} onChange={handleChange} className="w-full border rounded-md px-3 py-2" required />
          </div>
          
          <div>
            <label className="block text-gray-700 mb-2">Description</label>
            <textarea name="description" value={formData.description} onChange={handleChange} rows="3" className="w-full border rounded-md px-3 py-2" placeholder="Tell farmers and customers about your hub..." />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-700 mb-2">Delivery Radius (km)</label>
              <input type="number" name="deliveryRadiusKm" value={formData.deliveryRadiusKm} onChange={handleChange} className="w-full border rounded-md px-3 py-2" />
            </div>
            <div>
              <label className="block text-gray-700 mb-2">Commission Rate (%)</label>
              <input type="number" name="commissionRate" value={formData.commissionRate} onChange={handleChange} step="0.5" className="w-full border rounded-md px-3 py-2" />
            </div>
          </div>
          
          <div>
            <label className="block text-gray-700 mb-2">Minimum Order Amount ($)</label>
            <input type="number" name="minimumOrderAmount" value={formData.minimumOrderAmount} onChange={handleChange} className="w-full border rounded-md px-3 py-2" />
          </div>
          
          <div className="border-t pt-4 mt-4">
            <h3 className="font-semibold mb-3">Pickup Address</h3>
            <div className="space-y-3">
              <input type="text" name="pickupAddress.street" placeholder="Street Address" value={formData.pickupAddress.street} onChange={handleChange} className="w-full border rounded-md px-3 py-2" />
              <div className="grid grid-cols-2 gap-4">
                <input type="text" name="pickupAddress.suburb" placeholder="Suburb" value={formData.pickupAddress.suburb} onChange={handleChange} className="w-full border rounded-md px-3 py-2" />
                <input type="text" name="pickupAddress.state" placeholder="State" value={formData.pickupAddress.state} onChange={handleChange} className="w-full border rounded-md px-3 py-2" />
                <input type="text" name="pickupAddress.postcode" placeholder="Postcode" value={formData.pickupAddress.postcode} onChange={handleChange} className="w-full border rounded-md px-3 py-2" />
              </div>
            </div>
          </div>
          
          <button type="submit" disabled={loading} className="w-full bg-green-600 text-white py-2 rounded-md hover:bg-green-700 transition disabled:bg-gray-400">
            {loading ? 'Registering...' : 'Register Hub'}
          </button>
        </form>
        
        <p className="mt-4 text-center text-gray-600">
          Already registered? <Link to="/login" className="text-green-600 hover:underline">Login</Link>
        </p>
      </div>
    </div>
  );
}

